// extracted by mini-css-extract-plugin
export var tableOfContents = "styles-module--tableOfContents--hrtl2";
export var showButton = "styles-module--showButton--Gf-5h";
export var hideButton = "styles-module--hideButton--45ffO";
export var fadeIn = "styles-module--fadeIn--VlVmf";
export var fadeOut = "styles-module--fadeOut--2Qb2Z";